import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    //return '## WARNING ## The phrase for the key \'' + params.key + '\' has not been translated into your language. ## WARNING ##';
    return '\'' + params.key + '\'';
  }
}
